(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("procoreIframeHelpers", [], factory);
	else if(typeof exports === 'object')
		exports["procoreIframeHelpers"] = factory();
	else
		root["procoreIframeHelpers"] = factory();
})(window, function() {
return 